import { PageTitlesTranslation } from '@/assets/locales/pageTitles/pageTitles.translation.en.ts';
import { MenuItemEnum } from '@/components/layout/sidebar/sideBarMenu/model/SideBarMenuItems.model.tsx';

export const pageTitlesTranslation: PageTitlesTranslation = {
  [MenuItemEnum.ADMIN]: 'Panel admina',
  [MenuItemEnum.AREA]: 'Podległy obszar HRBP',
  [MenuItemEnum.CERTIFICATION]: 'Certyfikacja',
  [MenuItemEnum.CONTACT]: 'Kontakt',
  [MenuItemEnum.EMPLOYEE_PROFILE]: 'Indywidualny Profil Pracownika',
  [MenuItemEnum.EMPLOYEE_PROFILES_SEARCH]: 'Wyszukiwanie Pracowników',
  [MenuItemEnum.EMPLOYEE_PROFILES_SEARCH_AI]: 'Dopasowanie pracowników do stanowiska',
  [MenuItemEnum.GROUP_TRAININGS]: 'Szkolenia dla grup',
  [MenuItemEnum.KNOW_ME]: 'KnowMe',
  [MenuItemEnum.NESTED_STRUCTURE]: 'Struktura zagnieżdżona',
  [MenuItemEnum.NEWS]: 'Aktualności',
  [MenuItemEnum.NOTIFICATIONS]: 'Powiadomienia',
  [MenuItemEnum.ORGANIZATION_CHART]: 'Struktura organizacyjna',
  [MenuItemEnum.SUCCESSION]: 'Zarządzaj sukcesją',
  [MenuItemEnum.SUCCESSION_CHANGELOG]: 'Dziennik zmian sukcesji',
  [MenuItemEnum.TEAM]: 'Mój zespół',
  [MenuItemEnum.USERS_LIST]: 'Zarządzanie kontami',
};
